import { CircleOpacityIcon } from './CircleOpacityIcon';

/**
 * author: Michael Irigoyen
 * id 912F4CEF-F852-49C4-B9BB-A6504988C11E
 * name circle-opacity
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-opacity.svg
 * tags
 * - Shape 
 * - Drawing / Art 
 */
export const CircleTransparentIcon = CircleOpacityIcon;
export default CircleTransparentIcon